import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Fetch } from "../../../shared/Fetch";
import { AllRating } from "./AllRating";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";

export interface IFilter {
    fromDate?: Date,
    toDate?: Date,
    trainers?: string;
    company?: number | null,
    branch?: number | null,
}

interface IProps {
    toast: any
}

export interface ICompletedTrainingsRating {
    login_ID?: number,
    user_Name?: string,
    company_Name?: string,
    branchName?: string,
    schedule_ID?: number,
    form_ID?: number,
    training_Status_ID?: number,
    training_Status?: boolean,
    noOfUsersRated?: number,
    averageRating?: number
}


export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICompletedTrainingsRating>, loading: boolean });
    const [openRatingsView, setOpenRatingsView] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ICompletedTrainingsRating });
    const [filter, setFilter] = useState<IFilter>({});
    // const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICompletedTrainingsRating>, loading: boolean });

    const dt = useRef<any>(null);

    const header = () => {
        return <p>Training Ratings</p>;
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getCompletedTrainingsRating", "GET", null, `filter=${JSON.stringify(filter)}`, props.toast);
        if (response) {
            const data: ICompletedTrainingsRating[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const NoOfUsersRated = (rowData: ICompletedTrainingsRating) => {
        return <p className="cursor-pointer text-cyan-700 underline" onClick={() => {
            if (rowData?.noOfUsersRated !== undefined && rowData?.noOfUsersRated && rowData?.noOfUsersRated > 0) setOpenRatingsView({ open: true, singleData: rowData });
        }}>{rowData.noOfUsersRated}</p>;
    }

    const ratingStars = (rowData: ICompletedTrainingsRating) => {
        let stars: string[] = ["★", "★", "★", "★", "★"];
        return <p>{stars.map((el: string, index: number) => <span style={{ color: index <= ((rowData.averageRating || 0) - 1) ? "#FFD700" : "#ccc" }}>{el}</span>)}</p>
    }

    useEffect(() => {
        loadTableData();
    }, [filter]);

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filter={filter} setFilter={setFilter} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="schedule_ID"
                emptyMessage="No Record found."
                value={tableData.tableData} loading={tableData.loading}
                header={header}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="Trainer" />
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
                <Column field="topic_Name" header="Topic" />
                <Column field="category_Name" header="Category" />
                <Column field="training_Branch" header="Training Branch" />
                <Column field="averageRating" header="Average Rating" body={ratingStars} />
                <Column field="noOfUsersRated" header="No Of Users Rated" body={(rowData: ICompletedTrainingsRating) => NoOfUsersRated(rowData)} />
            </DataTable>
            <AllRating open={openRatingsView.open} singleData={openRatingsView.singleData} hideDialog={() => setOpenRatingsView({ open: false, singleData: {} })} toast={props.toast} />
        </>
    );
}